// src/components/BlockItem.jsx
import React from 'react';
import PropTypes from 'prop-types';

function BlockItem({ block, onDragStart }) {
  return (
    <div
      className="block-item"
      draggable
      onDragStart={(e) => {
        e.dataTransfer.effectAllowed = 'copy';
        onDragStart();
      }}
    >
      <span className="block-item-icon">{block.icon}</span>
      <span className="block-item-label">{block.label}</span>
    </div>
  );
}

BlockItem.propTypes = {
  block: PropTypes.shape({
    icon: PropTypes.node,
    label: PropTypes.node,
  }).isRequired,
  onDragStart: PropTypes.func.isRequired,
};

export default BlockItem;
